export enum Role {
    Client = 'Client',
    StuartStaff = 'StuartStaff',
    SE = 'SE',
}

export enum Permission {
    ADMIN_PAGE_VIEW = 'admin-page:view',
    CLIENT_PAGE_VIEW = 'client-page:view',
    CLIENT_LIST_SECTION_VIEW = 'client-list-section:view',
    CLIENT_FORM_SECTION_VIEW = 'client-form-section:view',
    CLIENT_VIEW = 'client:view',
    CLIENT_ADD = 'client:add',
    CLIENT_EDIT = 'client:edit',
    CLIENT_DELETE = 'client:delete',
    FT_AUTOSTACKING_ADD = 'ft-autostacking:add',
    FT_AUTOSTACKING_EDIT = 'ft-autostacking:edit',
    FT_AUTOSTACKING_DELETE = 'ft-autostacking:delete',
    JOB_PAGE_VIEW = 'job-page:view',
    JOB_LIST_SECTION_VIEW = 'job-list-section:view',
    JOB_DETAIL_SECTION_VIEW = 'job-detail-section:view',
    STACK_LIST_SECTION_VIEW = 'stack-list-section:view',
    STACK_DETAIL_SECTION_VIEW = 'stack-detail-section:view',
}

export type PermissionTypes = {
    static?: Permission[];
    dynamic?: {
        [y: string]: () => boolean;
    };
};

export type PermissionRules = {
    [key in Role]: PermissionTypes;
};
